import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./components/theme-provider";
import { Toaster } from "./components/ui/toaster";
import { Loading } from "./components/ui/loading";
import { routes } from "./constants/routeConfig";
import { LanguageProvider } from "./contexts/LanguageContext";
import { NavigationProvider } from "./contexts/NavigationContext";
import "./style.css";

const LoadingFallback = () => (
  <div className="flex h-screen items-center justify-center">
    <Loading size="lg" color="border-teal-500" />
  </div>
);

function App() {
  const element = useRoutes(routes);

  return (
    <Suspense fallback={<LoadingFallback />}>
      {element}
      <Toaster />
    </Suspense>
  );
}

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <LanguageProvider>
        <AuthProvider>
          <NavigationProvider>
            <App />
          </NavigationProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  </BrowserRouter>
);
